module.exports = __webpack_public_path__ + "static/media/07.dc4f9c7c.webp";